module.exports = __webpack_public_path__ + "static/media/IMPORT_BULK_UPLOAD_ATHENA_WITHOUT_VAT_PARTNER.c7c0c9e0.xlsx";